import { hasWindow } from '../utils';
import { isMobile } from '../utils/browserDetector';
import { projectIsTemplate } from './project-model';

export function isUsersProject(user, projectId) {
    const userOwnsProjectIds = user && user.ownerOfProjectIds ? user.ownerOfProjectIds : [];
    return userOwnsProjectIds.includes(projectId);
}

export function isMyProjects(userId, projects = []) {
    return projects?.filter((p) => p.owner_id === userId && !projectIsTemplate(p));
}

export const getUsersProjectIds = (state) => state.projects?.usersProjectIds || {};

export function mergeVersionWithProject(project, projectVersion = {}) {
    if (!project) {
        return null;
    }

    project.title = projectVersion.title || project.title;
    project.description = projectVersion.description || project.description;
    project.descriptionHtml = projectVersion.descriptionHtml || project.descriptionHtml;
    project.ends_at = projectVersion.ends_at || project.ends_at;
    project.img_url = projectVersion.img_url || project.img_url;
    project.purpose = projectVersion.purpose || project.purpose;
    project.moneygoal = projectVersion.moneygoal || project.moneygoal;
    project.goalType = projectVersion.goalType || project.goalType;
    project.published_at = projectVersion.published_at || project.published_at;
    project.created_at = projectVersion.created_at || project.created_at;

    return project;
}

export const canUseNativeShare = () => hasWindow() && window.navigator.share && navigator.canShare && isMobile();
